<template>
  <AppDialog :is-open="isDialogOpened"
             size="xxxl"
             :ok-text="$t('common.confirm')"
             :ok-disabled="!canConfirmSwap"
             :ok-loading="uploadHiddenFilePendingIds.length > 0"
             @cancel="onCancelSwap"
             @ok="onConfirmSwap"
  >
    <template #title>
      {{ $t("project.signing-checklist.dialogs.SwapFilesDialog.title") }}
    </template>
    <template #subTitle>
      <span class="text--small">
        {{ $t('project.signing-checklist.add.step1.SigningChecklistAddStep1.acceptedFilesAlertWithWord', { maxSize: maxSignableSize, maxPages: maxSignablePages }) }}
      </span>
    </template>
    <template #body>
      <div class="d-flex flex-column row-gap-4 swap-files-wrapper">
        <SwapFilesSelector v-for="swapFile in swapFiles.steps"
                          :key="swapFile.id"
                          :mnemo="mnemo"
                          :swapFile="swapFile"
                          @reset-swap="resetSwap(swapFile.id)"
                          @add-swap-file="onAddSwapFile"
        />
      </div>
    </template>
  </AppDialog>
</template>

<script>
import { defineComponent } from 'vue'
import { mapState, mapGetters } from 'vuex'

import AppDialog from '@/common/dialogs/AppDialog.vue'
import { dialogMixin } from '@/mixins/dialogMixin'
import SwapFilesSelector from '@/project/signing-checklist/SwapFilesSelector.vue'

export default defineComponent({
  name: 'SwapFilesDialog',
  components: {
    AppDialog,
    SwapFilesSelector,
  },
  mixins: [dialogMixin],
  props: {
    mnemo: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      swapFilesToProcess: [],
      nbFilesSwapped: 0,
    }
  },
  computed: {
    ...mapState('documents', ['uploadHiddenFilePendingIds']),
    ...mapState('signingChecklist', ['swapFiles']),
    ...mapGetters('room', ['maxSignableSize']),

    canConfirmSwap () {
      return this.nbFilesSwapped !== 0
    },
    maxSignablePages () {
      return import.meta.env.VUE_APP_MAX_SIGNABLE_PAGES
    },
  },
  methods: {
    onAddSwapFile (swapData) {
      const swapFileIndex = this.swapFilesToProcess.findIndex(swapFile => swapFile.envelopeId === swapData.envelopeId)

      if (swapFileIndex !== -1) {
        this.swapFilesToProcess.splice(swapFileIndex, 1, swapData)
        } else {
          this.swapFilesToProcess.push(swapData)
          this.nbFilesSwapped++
      }
    },
    onCancelSwap () {
      if (this.swapFilesToProcess.length > 0) {
        this.$emit('cancel-swap')
      } else {
        this.resetSwap()
        this.closeDialog()
      }
    },
    async onConfirmSwap () {
      this.$emit('confirm', this.swapFilesToProcess)
      this.closeDialog()
    },
    resetSwap (swapFileId) {
      const swapFileIndex = this.swapFilesToProcess.findIndex(swapFile => swapFile.id === swapFileId)
      this.swapFilesToProcess.splice(swapFileIndex, 1)
      this.nbFilesSwapped--
    },
  },
})
</script>

<style scoped lang="scss">
.v-card__subtitle span {
  color: rgb(var(--v-theme-grey-900));
}
.swap-files-wrapper {
  min-height: 50vh;
}
</style>
